import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { activitiesAPI } from '../api/client';
import { Footprints, Coffee, Mountain, Landmark, Bike, UtensilsCrossed, MapPin, CircleHelp } from 'lucide-react';
import '../styles/join-activity.css';

const ICONS = { run: Footprints, coffee: Coffee, hike: Mountain, museum: Landmark, cycling: Bike, dinner: UtensilsCrossed, other: MapPin };

function formatDate(str) {
  if (!str) return 'Flexible';
  return new Date(str).toLocaleDateString('en-US', {
    weekday: 'long', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}

export default function JoinActivity() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [activity, setActivity] = useState(null);
  const [error, setError] = useState('');

  const isLoggedIn = !!localStorage.getItem('token');

  useEffect(() => {
    activitiesAPI.getByInviteToken(token)
      .then((res) => setActivity(res.data))
      .catch(() => setError('This invite link is invalid or has expired.'));
  }, [token]);

  const handleJoin = () => {
    if (isLoggedIn) {
      navigate(`/activity/${activity.id}`);
    } else {
      navigate(`/register?redirect=/activity/${activity.id}&intent=rsvp`);
    }
  };

  if (error) {
    return (
      <div className="join-container">
        <div className="join-card">
          <div className="join-emoji"><CircleHelp size={36} color="#bbb" /></div>
          <h1>Link not found</h1>
          <p className="join-error">{error}</p>
          <button className="btn-primary" onClick={() => navigate('/')}>Go to Covo</button>
        </div>
      </div>
    );
  }

  if (!activity) {
    return <div className="join-container"><p style={{ color: '#bbb' }}>Loading…</p></div>;
  }

  return (
    <div className="join-container">
      <div className="join-card">
        <div className="join-emoji">
          {React.createElement(ICONS[activity.activity_type] || MapPin, { size: 36, color: '#52AAD8', strokeWidth: 1.8 })}
        </div>
        <h1>{activity.title || activity.activity_type}</h1>
        <p className="join-host">Hosted by {activity.creator_name}</p>

        <div className="join-details">
          <div className="join-detail-row">
            <span className="join-detail-label">When</span>
            <span>{formatDate(activity.start_time)}</span>
          </div>
          {activity.location_name && (
            <div className="join-detail-row">
              <span className="join-detail-label">Where</span>
              <span>{activity.location_name}</span>
            </div>
          )}
          {activity.duration_minutes && (
            <div className="join-detail-row">
              <span className="join-detail-label">Duration</span>
              <span>{activity.duration_minutes} min</span>
            </div>
          )}
          {activity.description && (
            <div className="join-detail-row">
              <span className="join-detail-label">About</span>
              <span>{activity.description}</span>
            </div>
          )}
        </div>

        {activity.rsvp_count > 0 && (
          <p className="join-rsvp-count">{activity.rsvp_count} {activity.rsvp_count === 1 ? 'person' : 'people'} going</p>
        )}

        <div className="join-cta">
          <button className="btn-primary" onClick={handleJoin}>
            {isLoggedIn ? "View activity" : "I'm in — join Covo"}
          </button>
          {!isLoggedIn && (
            <button className="btn-tertiary" onClick={() => navigate(`/login?redirect=/activity/${activity.id}&intent=rsvp`)}>
              Already have an account? Log in
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
